import Vue from 'vue';
import { Badge, Button, Col, Container, Form, Header, Input, Main, Row, } from 'element-ui';
// @ts-ignore
import lang from 'element-ui/lib/locale/lang/en';
// @ts-ignore
import locale from 'element-ui/lib/locale';
import 'element-ui/lib/theme-chalk/index.css';

locale.use(lang);
Vue.use(Badge);
Vue.use(Button);
Vue.use(Col);
Vue.use(Container);
Vue.use(Header);
Vue.use(Input);
Vue.use(Form);
Vue.use(Main);
Vue.use(Row);



// WEBPACK FOOTER //
// ./src/plugins/ElementUI.ts